import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { DispatchAction } from "../state/State.js";
import { frameworkActions } from "../state/FrameworkReducer.js";
import { uiActions } from "../state/UiReducer.js";

/**
 * @name CounterValue
 * @class CounterValue
 * @extends {ConnectedHTMLElement}
 */
export class SettingBar extends ConnectedHTMLElement {
  static observedAttributes = ["player"];
  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    const gameStarted =
      oldState.currentGame === undefined && newState.currentGame !== undefined;
    const gameReStarted =
      oldState.currentGame?.ended === true &&
      newState.currentGame?.ended === false;
    const gameEnded =
      oldState.currentGame?.ended === false &&
      newState.currentGame?.ended === true;
    if (gameStarted || gameReStarted || gameEnded) {
      this.render();
    }
  }

  registerEvents() {
    const player = this.getAttribute("player");
    const reset = this.querySelector("#reset");

    reset.addEventListener("click", (e) => {
      e.preventDefault();
      DispatchAction(frameworkActions.resetBase, player);
      DispatchAction(uiActions.toggleSelectBase, { show: true, player });
    });

    const settings = this.querySelector("#settings");
    if (settings !== null) {
      settings.addEventListener("click", (e) => {
        e.preventDefault();
        DispatchAction(uiActions.toggleSettings, { show: true, player });
      });
    }
    const log = this.querySelector("#log");
    log.addEventListener("click", (e) => {
      e.preventDefault();
      DispatchAction(uiActions.toggleLog, { show: true, player });
    });

    const winner = this.querySelector("#winner");
    if (winner) {
      winner.addEventListener("click", (e) => {
        e.preventDefault();
        DispatchAction(uiActions.togglePickWinnerModal, { show: true, player });
      });
    }
  }

  render() {
    const gameStarted = this.state.currentGame !== undefined;
    const gameEnded = this.state.currentGame?.ended;
    this.innerHTML = `
      <div class="absolute bottom-0 left-0 flex flex-row justify-between items-center p-1 z-[100] w-[calc(100%-2rem)]">
        <button title="Reset base" id="reset" class="border-0 cursor-pointer rounded-full bg-black p-2 ${gameStarted ? "hidden" : ""}">
          <img src="/assets/icons/reset.svg" alt="Reset arrow" width="24" height="24">
        </button>

        <button title="Set winner" id="winner" class="border-0 cursor-pointer rounded-full bg-black p-2 ${gameStarted ? "" : "hidden"} ${gameEnded ? "hidden" : ""}">
          <img src="/assets/icons/medal.svg" alt="Medal" width="24" height="24">
        </button>

        <button title="Open log" id="log" class="border-0 cursor-pointer rounded-full bg-black p-2 ${gameStarted ? "" : "hidden"}">
          <img src="/assets/icons/book.svg" alt="Log" width="24" height="24">
        </button>

      </div>`;
    this.registerEvents();
  }

  connectedCallback() {
    this.render();
  }
}
